module.exports = __webpack_public_path__ + "static/ariston_1920-1675a36bdf19c863f9441c05324a479a.png";